var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserAddGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.57199 9.5714C11.7022 9.5714 13.4291 7.8445 13.4291 5.71426C13.4291 3.58402 11.7022 1.85712 9.57199 1.85712C7.44175 1.85712 5.71484 3.58402 5.71484 5.71426C5.71484 7.8445 7.44175 9.5714 9.57199 9.5714Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.71456 22.4285H1.85742V19.8571C1.87107 18.5505 2.21567 17.2686 2.85903 16.1312C3.5024 14.9939 4.42354 14.0382 5.53641 13.3533C6.64928 12.6685 7.91757 12.2769 9.22282 12.2151C10.5281 12.1533 11.8277 12.4233 13.0003 13",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19 13.8571V24.1428",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.8574 19H22.1431",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserAddGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user_add_gray.e93344e0d9a98d0e124643a4a11f9739.svg";